import { FC, useState, useCallback, MouseEvent } from 'react';

import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';

import { useMenuCardStyles } from './styles/menu-card.styles';
import { DeleteIcon } from '../../assets/Icons/Icons';
import { mcpChatTranslationRef } from '../../translation';

interface ConversationMenuCardProps {
  isStarred: boolean;
  onToggleStar: () => void;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  onRename: () => void;
}

export const ConversationMenuCard: FC<ConversationMenuCardProps> = ({
  // isStarred,
  // onToggleStar,
  onClick,
  onRename,
}) => {
  const classes = useMenuCardStyles();
  const { t } = useTranslationRef(mcpChatTranslationRef);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);

  const handleMenuClick = useCallback((event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  }, []);

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  //   const handleStarClick = useCallback(() => {
  //     handleMenuClose();
  //     onToggleStar();
  //   }, [handleMenuClose, onToggleStar]);

  const handleDeleteClick = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      handleMenuClose();
      onClick(event);
    },
    [handleMenuClose, onClick],
  );

  const handleRenameClick = useCallback(() => {
    handleMenuClose();
    onRename();
  }, [handleMenuClose, onRename]);

  return (
    <>
      <Tooltip title={t('conversationMenuCard.tooltip')} arrow>
        <IconButton
          aria-label={t('conversationMenuCard.ariaLabel')}
          aria-controls={openMenu ? 'conversation-menu' : undefined}
          aria-expanded={openMenu ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleMenuClick}
          size="small"
        >
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="conversation-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        className={classes.menuContainer}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: -4,
          horizontal: 'right',
        }}
        sx={{ ml: 1 }}
        MenuListProps={{
          autoFocusItem: false,
          'aria-labelledby': 'conversation-menu',
        }}
      >
        {/* <MenuItem onClick={handleStarClick}>
          {isStarred ? (
            <StarIcon fontSize="small" sx={{ color: '#FFB400' }} />
          ) : (
            <StarBorderIcon fontSize="small" sx={{ color: 'inherit' }}  />
          )}
          <ListItemText
            primaryTypographyProps={{ className: classes.itemText }}
          >
            {isStarred ? 'Unstar' : 'Star'}
          </ListItemText>
        </MenuItem> */}
        <MenuItem onClick={handleRenameClick}>
          <EditIcon className={classes.renameIcon} />
          <ListItemText
            primaryTypographyProps={{ className: classes.itemText }}
          >
            {t('conversationMenuCard.rename')}
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={handleDeleteClick}>
          <DeleteIcon className={classes.deleteIcon} />
          <ListItemText
            primaryTypographyProps={{ className: classes.deleteText }}
          >
            {t('conversationMenuCard.delete')}
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
